<template>
    <div :style="sizeStyles" v-if="todisplay" v-show="isvisible" :class="{ 'c-MediaApproval': true, [`c-name-${name || 'unnamed'}`]: true }">
        <q-card v-if="deviceStatus === 2" class="q-ma-md q-mt-sm q-ml-sm q-mr-sm rounded-borders c-FeedbackBanner c-MediaApproval-card" :style="feedbackBannerStyle">
            <q-card-section>
                <div style="padding: 8px 0; white-space: normal; word-break: break-word;">
                    <TranslationContainer :context="context" value="Please click"></TranslationContainer>
                    <q-btn
                        flat
                        no-caps
                        :style="{ color: feedbackBannerStyle.color }"
                        @click="checkForAccess()"
                    >
                        <TranslationContainer :context="context" value="here"></TranslationContainer>
                    </q-btn>
                    <TranslationContainer :context="context" value="to bring up the approval window."></TranslationContainer>
                </div>
            </q-card-section>
        </q-card>
        <q-banner
            v-else
            v-show="!alertDismissed"
            inline-actions
            class="q-mb-md q-mt-sm q-ml-sm q-mr-sm rounded-borders c-FeedbackBanner c-MediaApproval-banner"
            :style="feedbackBannerStyle"
        >
            <template #avatar>
                <q-icon :name="icon" size="sm" :style="{ color: feedbackBannerStyle.color }" />
            </template>
            <div style="padding: 8px 0; white-space: normal; word-break: break-word;">
                <TranslationContainer :context="context" :value="message"></TranslationContainer>
                <span v-if="deviceStatus === 4">{{ deviceMessage }}</span>
            </div>
        </q-banner>
    </div>
</template>

<script>
import utils from '@/Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';
import careHelpfulFunctions from '../careHelpfulFunctions.jsx';
import { Vue } from '@/Shared/vueCompat.js';

import TranslationContainer from './TranslationContainer.jsx';

export default {
    name: "media-approval",
    mixins: [BaseComponent],
    components: {
        TranslationContainer
    },
    //Created Replaced with preRenderComplete
    data() {
        return {
            HAS_ACCESS: 0,
            WAITING: 1,
            HAS_DISMISSED: 2,
            HAS_BLOCKED: 3,
            OTHER_ERROR: 4,
            deviceStatus: 1,
            deviceMessage: '',
            setValueFunction: null,
            model: null,
            context: this,
            alertDismissed: false
        }
    },
    watch: {
        deviceStatus: function(newVal) {
            this.publishField = newVal;
        },
    },
    methods: {
        preRenderComplete() {
            this.checkForAccess();
            this.finishRenderHandler(this);
        },
        checkForAccess(){
            this.deviceStatus = this.WAITING;

            let constraints = {
                audio: true,
                video: false,
            };

            navigator.mediaDevices.getUserMedia(constraints).then(
                (stream) => {
                    this.deviceStatus = this.HAS_ACCESS;
                    stream.getAudioTracks()[0].stop();
                    this.onSuccessActions();
                },
                (result) => {
                    if (result.name == 'PermissionDeniedError')
                        this.deviceStatus = this.HAS_BLOCKED;

                    else if (result.name == 'PermissionDismissedError')
                        this.deviceStatus = this.HAS_DISMISSED;
                    
                    else if (result.name == "NotSupportedError" && window.location.protocol != "https:") {
                        this.deviceStatus = this.OTHER_ERROR;
                        this.deviceMessage = "Https required (currently using Http)";
                    }
                    else{
                        this.deviceStatus = this.OTHER_ERROR;
                        this.deviceMessage = result.name;
                    }
                }
            );
        },
        onSuccessActions() {
            if(this.controlData.OnSuccessActions)
                utils.executeAndCompileAllActions(this.controlData.OnSuccessActions, this.deviceStatus, this);
        }
    },
    computed: {
        feedbackBannerStyle() {
            let bgColor;
            let textColor;

            if (this.color === 'success') {
                bgColor = 'color-mix(in srgb, var(--v-success-base) 12%, transparent)';
                textColor = 'var(--v-success-base)';
            } else if (this.color === 'outbound') {
                bgColor = 'color-mix(in srgb, var(--v-outbound-base) 12%, transparent)';
                textColor = 'var(--v-outbound-base)';
            } else {
                bgColor = 'color-mix(in srgb, var(--v-error-base) 12%, transparent)';
                textColor = 'var(--v-error-base)';
            }

            return {
                backgroundColor: bgColor,
                color: textColor,
                width: '100%',
            };
        },
        sizeStyles() {
            return utils.getSize({...{ Width: { Mode: 'Fill' } }, ...this.sizeOptions}, this.parentType, this.$parent);
        },
        publishField: {
            set(value){
                if(this.setValueFunction === null && this.controlData.PublishField) {
                    let vueSet = utils.helpers.convertSetValueToVueSet(this.controlData.PublishField, 'value');
                    this.setValueFunction = new Function('value', 'context', 'util', 'vue', `with (context) { ${vueSet} }`);
                }
                if(this.setValueFunction) {
                    this.setValueFunction(value, this, careHelpfulFunctions, Vue);
                }
                this.model = value;
            },
            get() {
                return this.model;
            }
        },
        message() {
            switch(this.deviceStatus){
                case 0:
                    return 'You have given permission. Thanks!';
                case 1:
                    return 'Please click "Allow" to give permission to our site to access your microphone.';
                case 3:
                    return 'The device is currently blocked. Permission is needed in order to make and receive calls.';
                case 4:
                    return 'We received another error when attempting to access your microphone:';
                default:
                    return '';
            }
        },
        color() {
            switch(this.deviceStatus){
                case 0:
                    return 'success';
                case 1:
                case 2:
                    return 'outbound';
                case 3:
                case 4:
                    return 'error';
                default:
                    return 'error';
            }
        },
        icon() {
            switch(this.deviceStatus){
                case 0:
                    return 'mdi-check-circle';
                case 1:
                case 2:
                case 3:
                case 4:
                    return 'mdi-alert';
                default:
                    return 'mdi-alert';
            }
        }
    }
};
</script>

<style scoped>
</style>
